/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Bulk_Carrier_DescriptionInputs */



/**
* | output |
* | --- |
* | "Dry-bulk vetting inspections using the RISQ questionnaire, for RightShip and OCIMF members." |
*
* @param {Service_Bulk_Carrier_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_bulk_carrier_description = /** @type {((inputs?: Service_Bulk_Carrier_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Bulk_Carrier_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("为 RightShip 及 OCIMF 成员开展、采用 RISQ 问卷的干散货审查检查。")
	return /** @type {LocalizedString} */ ("Dry-bulk vetting inspections using the RISQ questionnaire, for RightShip and OCIMF members.")
});